import React, { Fragment, Suspense, useEffect } from "react";
import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";
import Loader from "./components/Loader";
import ScrollToTop from "./components/ScrollToTop";
import { useAuth } from "alpha-ui";
import RedirectSpinner from "./components/RedirectSpinner.js";
import NotificationPrompt from "./components/NotificationPrompt.js";


// Lazy-loaded pages
const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Login = React.lazy(() => import("./pages/Login"));
const Register = React.lazy(() => import("./pages/Register"));
const ForgetPassword = React.lazy(() => import("./pages/ForgetPassword"));
const Profile = React.lazy(() => import("./pages/Profile"));
const LabPage = React.lazy(() => import("./pages/LabPage"));
const Experiment = React.lazy(() => import("./pages/Experiment"));
const TeacherRegister = React.lazy(() => import("./pages/TeacherRegister.js"));
const StudentRegister = React.lazy(() => import("./pages/StudentRegister.js"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const TermsCondition = React.lazy(() => import("./pages/TermsCondition"));
const ChooseLabPage = React.lazy(() => import("./pages/ChooseLabPage"));
const PortfolioPage = React.lazy(() => import("./pages/PortfolioPage"));
const CareerCouncellingLab = React.lazy(() => import("./pages/CareerCouncellingLab"));
const Sitemap = React.lazy(() => import("./pages/Sitemap"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const PageNotFound = React.lazy(() => import("./pages/PageNotFound"));
const VerifyEmail = React.lazy(() => import("./pages/VerifyEmail.js"));
const EducationPartnerPage = React.lazy(() => import("./pages/EducationPartnerPage.js"));
const BecomePartner = React.lazy(() => import("./pages/BecomePartner.js"));

const App = () => {
  const { auth } = useAuth();
  
  const user = auth?.user;
  const loading = auth?.loading;


  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (let registration of registrations) {
          registration.update(); // Force update the service worker
        }
      });
    }

    const checkForUpdate = async () => {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration && registration.waiting) {
        if (window.confirm("A new version is available. Do you want to update?")) {
          registration.waiting.postMessage({ type: "SKIP_WAITING" });
          window.location.reload(); // Reload the app to apply updates
        }
      }
    };

    window.addEventListener("load", checkForUpdate);
    return () => window.removeEventListener("load", checkForUpdate);
  }, []);


  // IF LANGUAGE NOT AVAILABLE useEffect(() => {
    useEffect(() => {
      const storedLang = localStorage.getItem("expAddaLang");
      if (!storedLang) {
        localStorage.setItem("expAddaLang", "ENGLISH");
      }
    }, []);

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ScrollToTop />
          <NotificationPrompt />
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/login" element={<Login />} />
              <Route exact path="/register" element={<Register />} />
              <Route exact path="/register-as-teacher" element={<TeacherRegister />} />
              <Route exact path="/register-as-student" element={<StudentRegister />} />
              <Route exact path="/forgot-password" element={<ForgetPassword />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/contact" element={<Contact />} />
              <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route exact path="/terms-and-condtion" element={<TermsCondition />} />
              <Route exact path="/web-sitemap" element={<Sitemap />} />
              <Route exact path="/education-partners" element={<EducationPartnerPage />} />
              <Route exact path="/reset-password/:token" element={<ResetPassword />} />
              <Route exact path="/verify-email/:token" element={<VerifyEmail />} />
              <Route exact path="/become-partner" element={<BecomePartner />} />
              <Route path="/" element={user?._id ? <Outlet /> : <RedirectSpinner />}>
                <Route exact path="experiment" element={<Experiment />} />
                <Route exact path="profile" element={<Profile />} />
                <Route exact path="lab" element={<LabPage />} />
                <Route exact path="choose-lab" element={<ChooseLabPage />} />
                <Route exact path="portfolio" element={<PortfolioPage />} />
                <Route exact path="career-councelling-lab" element={<CareerCouncellingLab />} />
              </Route>
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </Suspense>
        </>
      )}
    </Fragment>
  );
};

export default App;
